import { useContext } from 'react';

import { SnackbarContext } from '@providers/SnackbarProvider';
import { useIntl } from 'utils/intl';

import messages from './CopyButton.messages';

type Props = {
  className?: string;
  copyText: string;
  copyMessage?: string;
  children?: (props: { onClick: () => void }) => JSX.Element;
};

const CopyButton = ({ className, copyText, copyMessage, children }: Props): JSX.Element => {
  const intl = useIntl();
  const { showMessage } = useContext(SnackbarContext);

  const onCopy = async () => {
    if ('navigator' in window && navigator.clipboard) {
      await navigator.clipboard.writeText(copyText);
      showMessage('info', copyMessage || intl.formatMessage(messages.copyMessage));
    }
  };

  return children ? (
    children({ onClick: onCopy })
  ) : (
    <button type="button" className={className} onClick={onCopy}>
      {intl.formatMessage(messages.copy)}
    </button>
  );
};

export default CopyButton;
